import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pula_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const FRIENDLY_CONNECTION =
  "Connection hiccup — please check your signal and try again in a moment.";

// Never let raw gateway/HTML error pages (e.g. Cloudflare 520/502) surface to the
// user. Normalise 5xx, gateway and network errors to a friendly message.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const res = error.response;
    if (!res) {
      // Network error / request never reached the server
      error.response = { data: { detail: FRIENDLY_CONNECTION } };
      return Promise.reject(error);
    }
    const body = res.data;
    const looksLikeHtml = typeof body === "string" && /<(!doctype|html|head|body)\b/i.test(body);
    if (res.status >= 500 || res.status === 429 || looksLikeHtml) {
      res.data = { detail: FRIENDLY_CONNECTION };
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") {
    // Guard against raw HTML/gateway error pages leaking into a toast.
    if (/<(!doctype|html|head|body)\b/i.test(detail) || detail.length > 300) {
      return "Something went wrong. Please try again.";
    }
    return detail;
  }
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
